import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import './style.css';

export interface ContactUsPageProps extends RouteComponentProps<{}> {}

export interface ContactUsPageState {
  /* empty*/
}

export class ContactUsPage extends React.Component<
  ContactUsPageProps,
  ContactUsPageState
> {
  render() {
    return (
      <main className="contact-us plain-content-page" role="main">
        <h1 className="contact-us-header plain-content-page-header">
          Contact Us
        </h1>
        <p>
          To find out more about Edge of Play, please contact us at:{' '}
          <a className="edge-of-play-link" href="mailto:admin@edgeofplay.com">
            admin@edgeofplay.com
          </a>
        </p>
      </main>
    );
  }
}

export default ContactUsPage;



// WEBPACK FOOTER //
// ./src/app/containers/ContactUsPage/index.tsx